<script setup>
const { $bus } = useNuxtApp();

const props = defineProps({
    session: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['close']);
const isSaveSeatLoading = ref(false);

const closeModal = () => {
    emit('close');
};

const handleSaveSeat = async () => {
    // Don't double click
    if (isSaveSeatLoading.value) return;
    isSaveSeatLoading.value = true;

    $bus.emit('handleSaveSeat', {
        session: props.session,
        isSaveSeatLoading,
        holdOpen: {
            activeModal: 'favoritesSavedReservationRequired',
        },
    });
};
</script>

<template>
    <div>
        <h2>"{{ session.title }}" has been added to My Favorites!</h2>
        <div class="modal-alert">
            <MessSvg class="warning-icon" type="warning" />
            <p class="fs-16">
                This session has a limited number of seats available and requires a seat reservation. Would you like to
                also save a
                seat?
            </p>
        </div>
        <div class="modal-action-buttons">
            <ProjectButtonSecondary type="submit" :disabled="isSaveSeatLoading" :loading="isSaveSeatLoading"
                :filledIn="true" @click="handleSaveSeat">
                YES, SAVE A SEAT FOR THIS SESSION
            </ProjectButtonSecondary>
            <ProjectButtonSecondary type="submit" :disabled="isSaveSeatLoading" :loading="isSaveSeatLoading"
                @click="closeModal">
                Don't save a seat
            </ProjectButtonSecondary>
        </div>
    </div>
</template>
